import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import headingStyles from '../heading/heading.css';
import linkStyles from '../link/link.css';
import styles from './markdown.css';
/**
  * @name Markdown
*/
export default class Markdown extends PureComponent {
    render() {
        const { className, children, inline } = this.props;
        const classes = classNames(className, headingStyles.contentWithHeadings, linkStyles.withLinks, {
            [styles.markdown]: !inline,
            [styles.inline]: inline
        });
        return (<div className={classes}>
        {children}
      </div>);
    }
}
Markdown.propTypes = {
    inline: PropTypes.bool,
    className: PropTypes.string
};
